import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlpha: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlpha"><Path d="M16.3 5.57143C15.6446 10.25 13.3161 19.5 8.83333 19.5C5.31224 19.5 3.46852 15.75 3.50044 12C3.53236 8.25 5.43991 4.5 8.83333 4.5C15.2333 4.5 13.5327 19.5 17.3667 19.5C19.2246 19.5 19.5 17.3571 19.5 16.2857" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlpha;
